import { combineReducers } from 'redux'
import { AnyAction, createAction, createReducer } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
// Import api after all other imports to ensure it's initialized last
import api from '@/core/api'
import { dmpConnectJS2Api } from '@/core/api/dmp-connect-js2'
import { tutorialsApi } from '@/core/api/tutorials'
import { connectorApi } from '@/core/api/connector'

import adminReducer from './reducers/admin.reducer'
import appReducer from './reducers/app.reducer'
import authReducer from './reducers/auth.reducer'
import bulkOrderReducer from './reducers/bulk-order.reducer'
import chargeReducer from './reducers/charge.reducer'
import chatRoomReducer from './reducers/chat-room.reducer'
import consultationReducer from './reducers/consultation.reducer'
import customDeviceReducer from './reducers/custom-device.reducer'
import documentReducer from './reducers/document.reducer'
import dmpConnectReducer from './reducers/dmp-connect.reducer'
import establishmentReducer from './reducers/establishment.reducer'
import expertiseReducer from './reducers/expertise.reducer'
import medecinReducer from './reducers/medecin.reducer'
import meetingLinkReducer from './reducers/meeting-link.reducer'
import orderReducer from './reducers/order.reducer'
import patientReducer from './reducers/patient.reducer'
import rocketChatReducer from './reducers/rocket-chat.reducer'
import roomReducer from './reducers/room.reducer'
import specialityOptionReducer from './reducers/speciality-option.reducer'
import staffReducer from './reducers/staff.reducer'
import statisticReducer from './reducers/statistic.reducer'
import waitingRoomReducer from './reducers/waiting-room.reducer'
import alertsReducer from './reducers/alerts.reducer'

const reducers = {
  [api.reducerPath]: api.reducer,
  [dmpConnectJS2Api.reducerPath]: dmpConnectJS2Api.reducer,
  [tutorialsApi.reducerPath]: tutorialsApi.reducer,
  [connectorApi.reducerPath]: connectorApi.reducer,
  admin: adminReducer,
  app: appReducer,
  alert: alertsReducer,
  auth: authReducer,
  bulkOrder: bulkOrderReducer,
  charge: chargeReducer,
  chatRoom: chatRoomReducer,
  consultation: consultationReducer,
  customDevice: customDeviceReducer,
  document: documentReducer,
  dmpConnect: dmpConnectReducer,
  establishment: establishmentReducer,
  expertise: expertiseReducer,
  medecin: medecinReducer,
  order: orderReducer,
  patient: patientReducer,
  rocketChat: rocketChatReducer,
  room: roomReducer,
  specialityOption: specialityOptionReducer,
  staff: staffReducer,
  statistic: statisticReducer,
  waitingRoom: waitingRoomReducer,
  meetingLink: meetingLinkReducer,
}

// Combine all reducers.
const appReducers = combineReducers(reducers)

export const resetStore = createAction<undefined>('resetStore')
export const startup = createAction<undefined>('startup')
export type RootState = ReturnType<typeof appReducers>

const rootReducer = (initialState: RootState) =>
  createReducer(initialState, (builder) => {
    builder.addDefaultCase((state, action) => appReducers(state, action))
  })

export const useAppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default rootReducer
